import {MenuItem, MenuService} from "../../Common/Component/Menu/MenuService";
import {addFormSchema} from "../FormPage/FormSchemaService";
import CurrentUserPage from "./User/CurrentUserPage";
import UserPerfilFormSchema from "../FormPage/UserPerfilFormSchema";
import LoginPage from "./Login/LoginPage";
import RecoveryPassword from "./RecoveryPassword/RecoveryPassword";

export const AuthModule = () => {

    const CURENT_USER_PAGE = MenuItem({
        name: 'Meus dados',
        path: 'me',
        canCreateRoute: true,
        canShowInMenu: false,
        element: <CurrentUserPage/>
    });


    const ENTRAR_PAGE = MenuItem({
        name: 'Entrar',
        path: 'entrar',
        canCreateRoute: true,
        canShowInMenu: false,
        element: <LoginPage/>,
        isPublic: true
    });

    const RECUPERAR_SENHA_PAGE = MenuItem({
        name: 'Recuperar Senha',
        path: 'recuperar-senha',
        canCreateRoute: true,
        canShowInMenu: false,
        element: <RecoveryPassword />,
        isPublic: true
    });

    MenuService.addMenu(CURENT_USER_PAGE);
    MenuService.addMenu(ENTRAR_PAGE);
    MenuService.addMenu(RECUPERAR_SENHA_PAGE);


    addFormSchema('profiles', UserPerfilFormSchema)


    return [];

}
